var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n        fill-rule: evenodd;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.41,0H2.58C1.16,0,0,1.16,0,2.59v11.27c0,1.43,1.16,2.59,2.58,2.59h3.35l.05-1.41h-3.4c-.65,0-1.18-.52-1.18-1.18V2.59c0-.65.53-1.18,1.18-1.18h1.58v1.21c0,.83.67,1.5,1.5,1.5h6.67c.83,0,1.5-.67,1.5-1.5v-1.21h1.58c.65,0,1.18.53,1.18,1.18v11.27c0,.66-.53,1.18-1.18,1.18h-2.6l-.91,1.41h3.51c1.43,0,2.59-1.16,2.59-2.59V2.59c0-1.43-1.16-2.59-2.59-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.89,10.75h-2.71l.08-4.51c0-.42-.55-.58-.79-.23l-4.73,7.24c-.18.29.02.66.36.66h2.74l-.02.9v.23s-.04,1.41-.04,1.41l-.05,1.97c0,.42.56.58.79.23l1.44-2.2.92-1.41.15-.23,2.22-3.4c.18-.29-.02-.66-.36-.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerMeter);
export default __webpack_public_path__ + "static/media/power-meter.b0c588b321ad861a63ca7423889dc8d7.svg";
export { ForwardRef as ReactComponent };